import { service } from '@/utils/request'
import { brainPower } from '@/api'
export interface IGameListRequestParam {
  /**
   * 页数；例如：1
   */
  pageNo?: number
  /**
   * 每页条数；例如：10
   */
  pageSize?: number

  merchantId?: string
}

export interface IGameListResponseParam {
  pageNo?: number
  pageSize?: number
  total?: number
  data?: Array<IGameListItem>
}
export interface IGameListItem {
  id?: string
  merchantId?: string
  problemTitle?: string
  problemContent?: string
  problemCreateTime?: string
  problemCreateUserId?: string
  sort?:Number
}

export interface IGameDetailResponseParam {
  /**
   * 请求返回编码
   */
  code?: string
  /**
   * 请求返回数据
   */
  data?: MerchantResponse
  /**
   * 请求返回消息
   */
  msg?: string
}
export interface MerchantResponse {

}


//常见问题设置列表
export function newList(param:any): Promise<any> {
  return service.post(`${brainPower.newListApi}`, param)
}
  //问题分类
export function dictTypeList(param:any): Promise<any> {
  return service.post(`${brainPower.dictTypeListApi}`, param)
}
//自动回复列表
export function autoList(param:any): Promise<any> {
  return service.post(`${brainPower.autoListApi}`, param)
}
//自动回复删除
export function autoDel(param:any): Promise<any> {
  return service.post(`${brainPower.autoDelApi}`, param)
}
//自动回复添加
export function autoAdd(param:any): Promise<any> {
  return service.post(`${brainPower.autoAddApi}`, param)
}
//自动回复编辑
export function autoEdit(param:any): Promise<any> {
  return service.post(`${brainPower.autoEditApi}`, param)
}
//自动回复刷新
export function autoFlush(): Promise<any> {
  return service.get(`${brainPower.autoFlushApi}`)
}
